// extracted by mini-css-extract-plugin
module.exports = {"emptyPage":"styles_emptyPage__Lq7FW"};